module.exports = __webpack_public_path__ + "static/media/WorkflowsOpenDrawerIcon.483547b3.svg";